import registrations from "./registrations";

const registrationService = [
    {
        matcher: 'registrations',
        reply: config => {
            return [200, registrations];
        }
    },
    {
        matcher: /registrations\/(.*)/,
        reply: config => {
            const uuid = /registrations\/(.*)/.exec(config.url)[1];
            const registration = registrations.find(registration => registration.uuid === uuid);
            return [200, registration];
        }
    }
]

export default registrationService;